import { useEffect } from "react";
import { useAuth } from "../lib/AuthContext";

const COLORS = {
  bg: "#F8F7F4",
  surface: "#FFFFFF",
  border: "#E2E0DA",
  text: "#1A1917",
  textSecondary: "#6B6860",
  textMuted: "#9C9889",
  accent: "#2B5CE6",
  accentLight: "#EBF0FD",
  orange: "#C4720A",
  orangeLight: "#FFF4E5",
  red: "#C53030",
  redLight: "#FEE7E7",
};

export default function PendingApproval() {
  const { profile, signOut, refreshProfile } = useAuth();
  const status = profile?.status || "pending";

  // Poll every 30 seconds to check if status changed
  useEffect(() => {
    const interval = setInterval(() => {
      refreshProfile();
    }, 30000);
    return () => clearInterval(interval);
  }, [refreshProfile]);

  return (
    <div style={{
      fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
      backgroundColor: COLORS.bg,
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20,
    }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />
      <div style={{ textAlign: "center", maxWidth: 440 }}>
        {/* Logo */}
        <div style={{
          width: 48, height: 48, borderRadius: 12, backgroundColor: COLORS.accent,
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          color: "#fff", fontWeight: 700, fontSize: 22, marginBottom: 20,
        }}>R</div>

        {status === "pending" && (
          <>
            <div style={{
              fontSize: 48, marginBottom: 16,
            }}>⏳</div>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: COLORS.text, margin: "0 0 12px", letterSpacing: "-0.02em" }}>
              Account Pending Approval
            </h1>
            <p style={{ fontSize: 14, color: COLORS.textSecondary, lineHeight: 1.6, margin: "0 0 8px" }}>
              Your recruiter account has been created and is awaiting approval
              from the careers team.
            </p>
            <p style={{ fontSize: 13, color: COLORS.textMuted, margin: "0 0 28px" }}>
              You'll get access to the dashboard once approved. This page
              checks automatically every 30 seconds.
            </p>
            <div style={{
              display: "inline-block", padding: "8px 16px", borderRadius: 8,
              backgroundColor: COLORS.orangeLight, color: COLORS.orange,
              fontSize: 13, fontWeight: 600,
            }}>
              Status: Pending Review
            </div>
          </>
        )}

        {status === "rejected" && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: COLORS.text, margin: "0 0 12px", letterSpacing: "-0.02em" }}>
              Account Not Approved
            </h1>
            <p style={{ fontSize: 14, color: COLORS.textSecondary, lineHeight: 1.6, margin: "0 0 28px" }}>
              Unfortunately, your recruiter account was not approved.
              Please contact the careers team for more information.
            </p>
            <div style={{
              display: "inline-block", padding: "8px 16px", borderRadius: 8,
              backgroundColor: COLORS.redLight, color: COLORS.red,
              fontSize: 13, fontWeight: 600,
            }}>
              Status: Not Approved
            </div>
          </>
        )}

        {status === "revoked" && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🚫</div>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: COLORS.text, margin: "0 0 12px", letterSpacing: "-0.02em" }}>
              Access Deactivated
            </h1>
            <p style={{ fontSize: 14, color: COLORS.textSecondary, lineHeight: 1.6, margin: "0 0 8px" }}>
              Your recruiter access has been deactivated by the careers team.
              You can no longer search candidates, view profiles, or send messages.
            </p>
            <p style={{ fontSize: 13, color: COLORS.textMuted, margin: "0 0 8px" }}>
              If you believe this was a mistake, please reach out to the careers
              team directly — they can reactivate your account at any time.
            </p>
            <p style={{ fontSize: 12, color: COLORS.textMuted, margin: "0 0 28px" }}>
              This page checks automatically — if your access is restored you'll
              be redirected to the dashboard.
            </p>
            <div style={{
              display: "inline-block", padding: "8px 16px", borderRadius: 8,
              backgroundColor: COLORS.redLight, color: COLORS.red,
              fontSize: 13, fontWeight: 600,
            }}>
              Status: Access Deactivated
            </div>
          </>
        )}

        <div style={{ marginTop: 32 }}>
          <button onClick={signOut} style={{
            padding: "10px 24px", borderRadius: 8, border: `1px solid ${COLORS.border}`,
            backgroundColor: COLORS.surface, color: COLORS.textSecondary, fontSize: 13,
            fontWeight: 600, fontFamily: "inherit", cursor: "pointer",
          }}>
            Log Out
          </button>
        </div>

        <p style={{ fontSize: 11, color: COLORS.textMuted, marginTop: 24 }}>
          {profile?.email && `Signed in as ${profile.email}`}
        </p>
      </div>
    </div>
  );
}
